import { Configuration } from '@bmw-forms/microservice-clients/dist/codegen/api/client/configuration';

export class APIHelper {
	/**
	 * Formats errors into FormIK friendly format
	 * 
	 * @param body
	 */
	static formatFieldErrors(body: { statusCode: number; message: Array<any>; error: string }) {
		let errors = {};
		if (body.message && body.message.length > 0) {
			body.message.forEach((error) => {
				if (typeof error === 'object') {
					errors = {
						...errors,
						[error.property]: error.constraints[Object.keys(error.constraints)[0]],
					};
				}
			});
		}
		return errors;
	}

	/**
	 * Handle exceptions
	 *
	 * @param error
	 */
	static handleExceptions(error: any) {
		if (error.statusCode === 400 && typeof error.message === 'object') {
			return {
				success: false,
				errors: APIHelper.formatFieldErrors(error.body), // TO_DO: Look if still correct.
			};
		} else {
			return {
				success: false,
				message: error.message,
			};
		}
	}

	static handleResponse(rawResponse) {
		try {
			const response = rawResponse;
			// const success = response.statusCode >= 200 && response.statusCode < 300;

			return { success: true, ...response };
		} catch (error) {
			return { success: false, message: 'Service is temporarily down' };
		}
	}

	/**
	 * Add token to API requests
	 *
	 * @param cls
	 */
	static addToken(cls: any) {
		const accessToken = localStorage.getItem('accessToken');
		if (!accessToken) {
			return null;
		}
		const apiKeyAuth = new Configuration();
		apiKeyAuth.apiKey = 'bearer ' + accessToken;

		const classObject = new cls(apiKeyAuth);
		return classObject;
	}
}
